import { type ContactDetail, type ModifiedContactDetail } from '@shared/types/ContactDetail';
import { useAppStore } from '@/shared/stores/AppStore';
import { Geolocation } from '@/modules/profile-page/helpers/Geolocation';
import { UrlHelper } from '@/shared/helper/UrlHelper';
import { sortElementArray } from '@/shared/utils/SortElementArray';

export default class ContactDetailsProcessor {
  private contactDetails: ContactDetail[];
  private contactDetailId: number | undefined;
  private userCoordinates: number[];
  private contactDetailsWithDistance: ModifiedContactDetail[] = [];

  constructor(contactDetails: ContactDetail[]) {
    const { contactDetailId, fallbackCoordinates } = useAppStore();
    this.contactDetails = contactDetails;
    this.contactDetailId = contactDetailId;
    this.userCoordinates = fallbackCoordinates;
  }

  async nearestLocation(): Promise<ModifiedContactDetail[]> {
    return [...this.contactDetailsWithDistance].sort((a, b) => {
      return a.calculatedDistance - b.calculatedDistance;
    });
  }

  async addCalculatedDistance(): Promise<ModifiedContactDetail[]> {
    return await Promise.all(
      this.contactDetails.map(async (contact) => ({
        ...contact,
        calculatedDistance: await Geolocation.calculate(contact.coordinates),
      }))
    );
  }

  async process(): Promise<ModifiedContactDetail[]> {
    this.contactDetailsWithDistance = await this.addCalculatedDistance();
    if (this.contactDetailId) {
      if (this.contactDetails.find((contact) => contact.id === this.contactDetailId)) {
        return sortElementArray(this.contactDetailsWithDistance, 'id', this.contactDetailId);
      }
      UrlHelper().update(this.contactDetailId.toString());
    }

    if (Geolocation.isBrowserLocationEnabled()) {
      return this.nearestLocation();
    }
    return this.contactDetailsWithDistance;
  }
}
